import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		apiDomain: "https://api-assistel.herokuapp.com",
		mailService: {
			host: "ssl0.ovh.net",
			port: 465,
			auth: {
					user: "contact@assistel.paris",
					pass: "Assistel78"
			}
		},
		stripe: {
			// Live keys
			js: window.Stripe("pk_live_51HZAmTIuzUw34PjEVimspmW1fSNBWswJ517biRgptWWaikrPmvPBUJvr2q3magOWttsBQMUtv1GVNZIcjPNR1rvV00tmKwdU61"),
			sk: "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",

			// Test keys
			/* js: window.Stripe("pk_test_51HZAmTIuzUw34PjEtP63ZiPtOJ2NXrkB262dc22kXCsBW4gJAdM4QMJC21ja86pGGV3PeLWbB7efSuLd2VuM8b2t00aXD28Bae"),
			sk: "sk_test_51HZAmTIuzUw34PjEeSkYk8qjYmFdiW45jXR3JUorvCXqmLuiDSAuiHgqvYrpR2yl7dLAsgRKYu1HkcrgVMzWoOSA00Usl7EhC9", */
		},
		/* apiDomain: "http://localhost:5000",
		mailService: {
			host: "smtp.office365.com",
			port: 587,
			auth: {
				user: "sastourne.quentin@hotmail.fr",
				pass: "Upru3O#R39MK"
			}
		},
		stripe: {
			js: window.Stripe("pk_test_51INv9VJ6ZttGV7hXPO974pFy0uAWOwF9gT8DjfFbIlAPBICRyGCXYAuGYlz6Jjy9HY9Cais7I0igAbBbX3K6FpSn00knfKqLwM"),
			sk: "sk_test_51INv9VJ6ZttGV7hXidjPN9II3qhCV49s82RGlmuLjL8Cyokhtf5EMRf5t2diM5xbj99UGNUTO6koXyr0Dw3MeUaO001OhqLTQn",
		}, */
		appName: "Assistel",
		assistant: {
			src: require("@/assets/images/pictures/woman.png"),
			alt: "Photo d'une femme"
		},
		legalForms: [
			{ text: 'EURL / SARL', value: 'EURL / SARL' },
			{ text: 'SAS', value: 'SAS' },
			{ text: 'SASU', value: 'SASU' },
			{ text: 'SCI', value: 'SCI' },
			{ text: 'Association', value: 'Association' },
			{ text: 'Auto-Entrepreneur / Micro-Entreprise', value: 'Auto-Entrepreneur / Micro-Entreprise' },
			{ text: 'Autre', value: 'Autre' }
		],
		countriesList: [
			"Afghanistan", "Afrique du Sud", "Albanie", "Algérie", "Allemagne", "Andorre", "Angola", "Antigua-et-Barbuda", "Arabie saoudite", "Argentine", "Arménie", "Australie", "Autriche", "Azerbaïdjan", "Bahamas", "Bahreïn", "Bangladesh", "Barbade", "Biélorussie", "Belgique", "Belize", "Bénin", "Bhoutan", "Bolivie", "Bosnie-Herzégovine", "Botswana", "Brésil", "Brunei", "Bulgarie", "Burkina Faso", "Burundi", "Cambodge", "Cameroun", "Canada", "Cap-Vert", "République centrafricaine", "Chili", "Chine", "Chypre (pays)", "Colombie", "Comores (pays)", "République du Congo", "République démocratique du Congo", "Corée du Sud", "Corée du Nord", "Costa Rica", "Côte d'Ivoire", "Croatie", "Cuba", "Danemark", "Djibouti", "République dominicaine", "Dominique", "Égypte", "Salvador", "Émirats arabes unis", "Équateur (pays)", "Érythrée", "Espagne", "Estonie", "États-Unis", "Éthiopie", "Fidji", "Finlande", "France", "Gabon", "Gambie", "Géorgie (pays)", "Ghana", "Grèce", "Grenade (pays)", "Guatemala", "Guinée", "Guinée-Bissau", "Guinée équatoriale", "Guyana", "Haïti", "Honduras", "Hongrie", "Inde", "Indonésie", "Iran", "Irak", "Irlande (pays)", "Islande", "Israël", "Italie", "Jamaïque", "Japon", "Jordanie", "Kazakhstan", "Kenya", "Kirghizistan", "Kiribati", "Koweït", "Laos", "Lesotho", "Lettonie", "Liban", "Liberia", "Libye", "Liechtenstein", "Lituanie", "Luxembourg (pays)", "Macédoine du Nord", "Madagascar", "Malaisie", "Malawi", "Maldives", "Mali", "Malte", "Maroc", "Îles Marshall (pays)", "Maurice (pays)", "Mauritanie", "Mexique", "États fédérés de Micronésie (pays)", "Moldavie", "Monaco", "Mongolie", "Monténégro", "Mozambique", "Birmanie", "Namibie", "Nauru", "Népal", "Nicaragua", "Niger", "Nigeria", "Norvège", "Nouvelle-Zélande", "Oman", "Ouganda", "Ouzbékistan", "Pakistan", "Palaos", "Panama", "Papouasie-Nouvelle-Guinée", "Paraguay", "Pays-Bas", "Pérou", "Philippines", "Pologne", "Portugal", "Qatar", "Roumanie", "Royaume-Uni", "Russie", "Rwanda", "Saint-Christophe-et-Niévès", "Saint-Marin", "Saint-Vincent-et-les-Grenadines", "Sainte-Lucie", "Salomon", "Samoa", "Sao Tomé-et-Principe", "Sénégal", "Serbie", "Seychelles", "Sierra Leone", "Singapour", "Slovaquie", "Slovénie", "Somalie", "Soudan", "Soudan du Sud", "Sri Lanka", "Suède", "Suisse", "Suriname", "Eswatini", "Syrie", "Tadjikistan", "Tanzanie", "Tchad", "Tchéquie", "Thaïlande", "Timor oriental", "Togo", "Tonga", "Trinité-et-Tobago", "Tunisie", "Turkménistan", "Turquie", "Tuvalu", "Ukraine", "Uruguay", "Vanuatu", "Venezuela", "Viêt Nam", "Yémen", "Zambie", "Zimbabwe"
		],
		maritalStatus: {
			male: [
				"Célibataire",
				"Concubin",
				"PACS",
				"Marié",
				"Divorcé",
				"Veuf"
			],
			female : [
				"Célibataire",
				"Concubine",
				"Pacsée",
				"Mariée",
				"Divorcée",
				"Veuve"
			]
		},
		services: {
			tva: 'HT',
			currency: '€',
			creation: {
				img: require('@/assets/images/pictures/company-creation.jpg'),
				price: {
					initial: 59,
					withOptions: 59,
					withDomiciliation: false
				},
				company: {
					name: null,
					rcs: null,
					activity: null,
					legalForm: null,
					headOffice: {
						location: null,
						fixation: null,
						address: {
							name: null,
							place: null,
							zipCode: null,
							city: null,
							registry: null
						}
					},
					socialObject: null,
					shareCapital: {
						amount: null,
						type: null,
						liberation: null,
						deposit: {
							location: null,
							name: null,
							address: {
								place: null,
								zipCode: null,
								city: null
							}
						}
					},
					fiscalYear: {
						dateOfFirst: null,
						closingDate: null,
						closingDateOfFirst: null
					},
					commercialDistinction: {
						acronym: {
							active: null,
							text: null
						},
						commercialName: {
							active: null,
							text: null
						},
						sign: {
							active: null,
							text: null
						}
					},
					representative: {
						name: {
							lastName: null,
							firstName: null
						},
						phone: null,
						mailAddress: null
					},
					generalManager: {
						exists: null,
						type: null,
						company: {
							name: null,
							rcs: null,
							headOffice: {
								place: null,
								zipCode: null,
								city: null,
								registry: null
							},
							shareCapital: null,
							socialForm: null
						},
						sex: null,
						name: {
							lastName: null,
							birthName: null,
							firstName: null,
							maritalName: null
						},
						maritalStatus: null,
						birth: {
							day: null,
							zipCode: null,
							city: null,
							nationality: null
						},
						address: {
							place: null,
							zipCode: null,
							city: null
						}
					},
					associates: [{
						type: null,
						company: {
							name: null,
							rcs: null,
							headOffice: {
								place: null,
								zipCode: null,
								city: null,
								registry: null
							},
							shareCapital: null,
							socialForm: null
						},
						sex: null,
						name: {
							lastName: null,
							birthName: null,
							firstName: null,
							maritalName: null
						},
						maritalStatus: null,
						birth: {
							day: null,
							zipCode: null,
							city: null,
							nationality: null
						},
						address: {
							place: null,
							zipCode: null,
							city: null
						},
						marriedUnderCommunityOfProperty: null,
						contribution: {
							numerary: {
								active: null,
								amount: null
							},
							inKind: {
								active: null,
								contributions: [null]
							}
						},
						alsoLeader: null
					}],
					leaders: [{
						type: null,
						company: {
							name: null,
							rcs: null,
							headOffice: {
								place: null,
								zipCode: null,
								city: null,
								registry: null
							},
							shareCapital: null,
							socialForm: null
						},
						sex: null,
						name: {
							lastName: null,
							birthName: null,
							firstName: null,
							maritalName: null
						},
						maritalStatus: null,
						birth: {
							day: null,
							zipCode: null,
							city: null,
							nationality: null
						},
						address: {
							place: null,
							zipCode: null,
							city: null
						},
						motherName: null,
						fatherName: null
					}]
				},
				options: [
					{
						text: "Assistance juridique",
						description: "Une couverture personnelle et professionnelle illimitée",
						image: {
							src: require('@/assets/images/icons/options/juridic-assistance.svg'),
							alt: "Document scellé"
						},
						price: 48,
						recurrence: null,
						engagement: true,
						freeTime: 0,
						active: false,
						tooltip: "En étant domicilié dans un centre Assistel, vous béneficier d'une <b>assistance juridique illimitée</b>, sans limite d'appels, pour vous aider à faire les meilleurs choix dans tous les domaines de la vie de votre entreprise, mais également votre vie privée."
					},
					{
						text: "Hébergement téléphonique",
						description: "Découvrez notre solution gratuitement pendant 3 mois",
						image: {
							src: require('@/assets/images/icons/options/phone-hosting.svg'),
							alt: "Téléphone portable avec un point de localisation"
						},
						price: 30,
						recurrence: 'mois',
						engagement: false,
						freeTime: 3,
						active: false,
						tooltip: "Communiquez à vos clients un numéro de téléphone différent de votre numéro personnel et profitez d'un répondeur téléphonique intelligent."
					},
					{
						text: "Permanance téléphonique",
						description: "Profitez d'un mois offert !",
						image: {
							src: require('@/assets/images/icons/options/hotline.svg'),
							alt: "Assistance téléphonique"
						},
						price: 59,
						recurrence: 'mois',
						engagement: false,
						freeTime: 1,
						active: false,
						tooltip: "Vous choisissez de transférer vos appels vers notre centre de contact selon vos besoins et vos contraintes"
					}
				],
				packs: [
					{
						text: "Pack Express",
						advantages: [
							"Relecture du dossier",
							"Rédaction statuts + m0 + Déclaration de non condamnation et d’affiliation",
							"Mise en conformité du dossier pour les institutions",
							"Formulaire MBE pour déclarer les bénéficiaires effectifs",
						],
						selfEmployedAdvantages: [
							"Déclaration auto-entrepreneur aux services compétents"
						],
						announcement: "Tous les frais pour l’annonce légale et l’immatriculation auprès du greffe sont à votre charge",
						image: {
							src: require('@/assets/images/icons/creation/packs/express.svg'),
							alt: "Médaille"
						},
						price: 59,
						active: true
					},
					{
						text: "Pack Premium",
						packIncluded: "Pack Express",
						advantages: [
							"Rédaction et frais de l’annonce légale"
						],
						announcement: null,
						image: {
							src: require('@/assets/images/icons/creation/packs/premium.svg'),
							alt: "Couronne"
						},
						price: 159,
						active: false
					},
					{
						text: "Pack Optimal",
						packIncluded: "Pack Premium",
						advantages: [
							"Frais de formalité au greffe",
							"Transmission au greffe"
						],
						announcement: null,
						image: {
							src: require('@/assets/images/icons/creation/packs/optimal.svg'),
							alt: "Diamant"
						},
						price: 379,
						active: false
					},
				]
			},
			domiciliation: {
				img: require('@/assets/images/pictures/company-domiciliation.jpg'),
				price: {
					initial: 39,
					withOptions: 39,
					warrantyDeposit: 78
				},
				addresses: [
					{
						text: 'Paris 2 - Opéra',
						value: 'Paris 2 - Opéra',
						address: {
							place: '53 Rue Sainte Anne',
							zipCode: '75002',
							city: 'Paris'
						},
						description: `
							Domiciliez votre entreprise dans le quartier de l'Opéra !
							<br />
							Choisir Paris 2 - Opéra, c'est profiter d'une <strong>adresse stratégique</strong> et offrir à sa société une <strong>image dynamique et internationale</strong>.
							<br /> <br />
							Profitez de nos services à la carte et de l'<strong>accueil professionnel et chaleureux</strong> de nos équipes pour <strong>développer votre activité</strong>.
							<br />
							Paris 2 - Opéra a reçu le <strong>label qualité</strong> du <strong>Synaphe</strong> (syndicat professionnel) et du <strong>SIST</strong>
						`,
						questions: [
							{
								title: "L'adresse Paris 2 - Opéra convient-elle à une jeune entreprise ?",
								answer: `
									<p>
										Il est obligatoire d’avoir une adresse postale pour le siège social d’une entreprise. Si plusieurs options existent pour cela (achat d’un local, à domicile...), la domiciliation via notre centre d’affaires Paris 2 – Opéra est particulièrement avantageuse pour une entreprise qui se lance :
									</p>

									<ul class="pl-4">
										<li>
											<strong>Démarches allégées</strong> : notre centre Paris 2 – Opéra limite le nombre de papiers à signer et de justificatifs à donner, vous avez plus de temps pour vous focaliser sur votre activité.
										</li>
										<br />
										<li>
											<strong>Frais limités</strong> : la domiciliation dans notre centre Paris 2 – Opéra épargne les coûts d’achat ou de location quand la trésorerie n’est pas encore forcément solide, pour un loyer à partir de 39 € HT/mois.
										</li>
									</ul>
								`
							},
							{
								title: "Pourquoi choisir de se domicilier à Paris 2 – Opéra avec Assistel ?",
								answer: `
									<p>
										Assistel, spécialiste de la <strong>domiciliation d’entreprise</strong> dispose des <strong>autorisations préfectorales</strong> pour son centre situé au 53 Rue Sainte-Anne à Paris 2e et vous propose une <strong>gamme complète</strong> de services pour votre entreprise et pour son développement.
										<br><br>
										En plus des services <strong>sur-mesure</strong> que nous proposons vous apprécierez le <strong>conseil</strong> et l’<strong>écoute</strong> de nos responsables de centres qui sont spécifiquement formés aux problématiques de l’entreprise.
										<br><br>
										Enfin, si vous avez besoin d’espace complémentaire, d’un <strong>bureau équipé</strong> ou d’une <strong>salle de réunion</strong> prestigieuse nous mettons à votre disposition ce qui se fait de mieux en termes d’<strong>espace de travail</strong>.
									</p>
								`
							}
						],
						img: {
							src: require('@/assets/images/pictures/opera-paris.jpg'),
							alt: 'Opéra de Paris'
						},
						srcMap: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2624.5055376413616!2d2.3339203156747046!3d48.86763857928834!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66e3ac1ce00bb%3A0xd23c7ea4010f1bb5!2s53%20Rue%20Sainte-Anne%2C%2075002%20Paris!5e0!3m2!1sfr!2sfr!4v1601837016810!5m2!1sfr!2sfr',
						price: 39,
						recurrence: 'mois'
					},
					{
						text: 'Paris 5 - Jardin des Plantes',
						value: 'Paris 5 - Jardin des Plantes',
						address: {
							place: '6 Rue Lacepède',
							zipCode: '75005',
							city: 'Paris'
						},
						description: `
							En domiciliant votre activité en plein cœur du 5e arrondissement, vous donnez à votre entreprise une <strong>image de marque renforcée</strong> auprès de vos clients et partenaires. Le charme du pittoresque Quartier Latin est à votre portée !
							<br />
							Profitez de notre <strong>service à la carte</strong> et de l’<strong>accueil professionnel et chaleureux</strong> de notre équipe pour <strong>développer votre entreprise</strong>.
							<br />
							Paris 5 – Jardin des Plantes est labellisé <strong>Synaphe</strong> (Association Professionnelle) et <strong>SIST</strong>.
						`,
						questions: [
							{
								title: "L’adresse Paris 5 — Jardin des Plantes convient-elle au démarrage ?",
								answer: `
									<p>
										Le siège social de l’entreprise doit disposer d’une adresse postale, c’est une obligation légale. Si les options de domiciliation sont nombreuses, notre centre d’affaires à Paris 5 — Jardin des Plantes présente de nombreux avantages pour les entreprises qui débutent :
									</p>

									<ul class="pl-4">
										<li>
											<strong>Facilitation des démarches</strong> : notre centre Paris 5 – Jardin des Plantes limite le nombre de documents à signer et le nombre de pièces justificatives à fournir, vous avez ainsi plus de temps pour vous concentrer sur vos activités.
										</li>

										<li>
											<strong>Frais diminués</strong> : domicilier votre entreprise, lorsque la trésorerie n’est pas encore stable, vous permet d’économiser sur les frais d’achat ou de location. Le loyer du centre Paris 5 – Jardin des Plantes est seulement de 39 € HT/mois.
										</li>
									</ul>
								`
							},
							{
								title: "Pourquoi se domicilier à Paris 5 – Jardin des Plantes avec Assistel ?",
								answer: `
									<p>
										Situé au n° 6 Rue Lacepède, 75 005 Paris, notre centre de domiciliation est habilité par l’État à fournir une <strong>gamme complète de services experts</strong> pour un <strong>meilleur développement de votre activité</strong>.
										<br /> <br />
										En plus de nos prestations sur-mesure, vous apprécierez également les <strong>conseils</strong> et l’<strong>écoute</strong> de nos responsables de centre spécialement formés.
										<br /> <br />
										Enfin, si vous avez besoin de plus d’espace, d’un <strong>bureau bien équipé</strong> ou d’une <strong>salle de réunion réputée</strong>, nous vous fournirons le meilleur de ce qui existe en terme d’<strong>espace de travail</strong>.
									</p>
								`
							}
						],
						srcMap: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2625.755060835252!2d2.351940215569199!3d48.84381060968736!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e671efd19cf74d%3A0x33413d0cf96de75!2s6%20Rue%20Lac%C3%A9p%C3%A8de%2C%2075005%20Paris!5e0!3m2!1sfr!2sfr!4v1601837094042!5m2!1sfr!2sfr',
						img: {
							src: require('@/assets/images/pictures/jardin-plantes-paris.jpg'),
							alt: 'Jardin des Plantes'
						},
						price: 39,
						recurrence: 'mois'
					}
				],
				company: {
					name: null,
					activity: null,
					address: {
						place: null,
						zipCode: null,
						city: null
					},
					legalForm: null,
				},
				domiciliation: {
					address: {
						name: null,
						place: null,
						zipCode: null,
						city: null
					},
					status: null,
					type: null,
					creationByAssistel: null
				},
				particulars: {
					name: {
						lastName: null,
						firstName: null,
					},
					birth: {
						day: null,
						place: {
							city: null,
							zipCode: null,
							country: null,
						}
					},
					address: {
						place: null,
						zipCode: null,
						city: null
					},
					mailAddress: null,
					phone: null
				},
				mailOptions: [
					{
						text: "Mise à disposition",
						value: 1,
						description: "Votre courrier disponible à votre adresse de domiciliation",
						image: {
							src: require('@/assets/images/icons/mail_options/available-courrier.svg'),
							alt: "Document scellé"
						},
						price: 0,
						recurrence: null,
						engagement: true,
						freeTime: 0,
						tooltip: null,
						active: false
					},
					{
						text: "Réexpédition hebdomadaire",
						value: 2,
						description: "Recevez votre courrier chaque semaine",
						image: {
							src: require('@/assets/images/icons/mail_options/courrier-expedition.svg'),
							alt: "Téléphone portable avec un point de localisation"
						},
						price: 15,
						recurrence: "mois",
						engagement: false,
						freeTime: 1,
						tooltip: "Recevez votre courrier de façon hébdomadaire à l'adresse de votre choix",
						active: false
					},
					{
						text: "Scan et envoi par email",
						value: 3,
						description: "Scan et envoi de votre courrier par email",
						image: {
							src: require('@/assets/images/icons/mail_options/courrier-numerisation.svg'),
							alt: "Assistance téléphonique"
						},
						price: 13,
						recurrence: "mois",
						engagement: false,
						freeTime: 1,
						tooltip: "Scan et envoi quotidien de votre courrier dès réception aux adresses email de votre choix",
						active: false
					}
				],
				options: [
					{
						text: "Service comptabilité",
						description: "Béneficiez d'un service comptabilité grâce à notre partenaire Efidia",
						image: {
							src: require('@/assets/images/icons/options/juridic-assistance.svg'),
							alt: "Document scellé"
						},
						price: 0,
						quote: true,
						recurrence: null,
						engagement: true,
						freeTime: 0,
						active: false,
						tooltip: "En étant domicilié dans un centre Assistel, vous béneficier d'un <b>service comptabilité</b>, sans limite d'appels, pour vous aider à faire les meilleurs choix dans tous les domaines de la vie de votre entreprise, mais également votre vie privée."
					},
					{
						text: "Hébergement téléphonique",
						description: "Découvrez notre solution gratuitement pendant 1 mois",
						image: {
							src: require('@/assets/images/icons/options/phone-hosting.svg'),
							alt: "Téléphone portable avec un point de localisation"
						},
						price: 29,
						quote: false,
						recurrence: 'mois',
						engagement: false,
						freeTime: 1,
						active: false,
						tooltip: "Communiquez à vos clients un numéro de téléphone différent de votre numéro personnel et profitez d'un répondeur téléphonique intelligent."
					},
					{
						text: "Permanence téléphonique",
						description: "Profitez d'un mois offert !",
						image: {
							src: require('@/assets/images/icons/options/hotline.svg'),
							alt: "Assistance téléphonique"
						},
						price: 59,
						quote: false,
						recurrence: 'mois',
						engagement: false,
						freeTime: 1,
						active: false,
						tooltip: "Vous choisissez de transférer vos appels vers notre centre de contact selon vos besoins et vos contraintes"
					}
				],
				pack: null
			}
		}
	},
	getters: {
		getDomiciliationAddresses(state) {
			return state.services.domiciliation.addresses;
		}
	},
	mutations: {
		updateCreationCompany(state, { company }) {
			Object.assign(state.services.creation.company, company);
		},
		updateRepresentative(state, { representative }) {
			state.services.creation.company.representative = representative;
		},
		updateGeneralManager(state, { generalManager }) {
			state.services.creation.company.generalManager = generalManager;
		},
		updateAssociates(state, { associates }) {
			let shareCapital = 0;

			associates.forEach(associate => {
				if (associate.contribution.numerary.active) {
					shareCapital += parseInt(associate.contribution.numerary.amount)
				}
			});

			state.services.creation.company.shareCapital.amount = shareCapital;

			state.services.creation.company.associates = associates;
		},
		updateLeaders(state, { leaders }) {
			state.services.creation.company.leaders = leaders;
		},
		updateCreationPack(state, { activePack }) {
			state.services.creation.packs.forEach(pack => {
				if (pack.active) {
					pack.active = false;
					state.services.creation.price.withOptions -= pack.price
				}
			});

			state.services.creation.packs[activePack].active = true;
			state.services.creation.price.withOptions += state.services.creation.packs[activePack].price
		},
		updateCreationOptions(state, { lastOptionClicked }) {
			if (state.services.creation.options[lastOptionClicked].active === false) {
				state.services.creation.options[lastOptionClicked].active = true;
				state.services.creation.price.withOptions += state.services.creation.options[lastOptionClicked].price
			} else {
				state.services.creation.options[lastOptionClicked].active = false;
				state.services.creation.price.withOptions -= state.services.creation.options[lastOptionClicked].price
			}
		},
		addDomiciliationFees (state, event ) {
			if (event === 'Domiciliation via Assistel') {
				state.services.creation.price.withOptions += state.services.domiciliation.price.initial;
				state.services.creation.price.withDomiciliation = true
			} else {
				if (state.services.creation.company.headOffice.location === 'Domiciliation via Assistel') {
					state.services.creation.price.withOptions -= state.services.domiciliation.price.initial
					state.services.creation.price.withDomiciliation = false
				}
			}
		},


		updateDomiciliationCompany(state, { company, domiciliation }) {
			state.services.domiciliation.company = company;
			state.services.domiciliation.domiciliation = domiciliation;
		},
		updateDomiciliationSalesAgentQuality(state, { salesAgentQuality }) {
				state.services.domiciliation.particulars.quality = salesAgentQuality;
		},
		updateDomiciliationParticulars(state, { particulars }) {
			state.services.domiciliation.particulars = particulars;
		},
		updateMail(state, { lastOptionClicked }) {
			if (state.services.domiciliation.mailOptions[lastOptionClicked].active === false) {
				state.services.domiciliation.mailOptions[lastOptionClicked].active = true;
				state.services.domiciliation.price.withOptions += state.services.domiciliation.mailOptions[lastOptionClicked].price
			} else {
				state.services.domiciliation.mailOptions[lastOptionClicked].active = false;
				state.services.domiciliation.price.withOptions -= state.services.domiciliation.mailOptions[lastOptionClicked].price
			}
		},
		updateDomiciliationOptions(state, { lastOptionClicked }) {
			if (state.services.domiciliation.options[lastOptionClicked].active === false) {
				state.services.domiciliation.options[lastOptionClicked].active = true;
				state.services.domiciliation.price.withOptions += state.services.domiciliation.options[lastOptionClicked].price
			} else {
				state.services.domiciliation.options[lastOptionClicked].active = false;
				state.services.domiciliation.price.withOptions -= state.services.domiciliation.options[lastOptionClicked].price
			}
		},
		updateDomiciliationPack(state, { activePack }) {
			if (state.services.domiciliation.pack) {
				state.services.domiciliation.price.withOptions -= state.services.creation.packs[state.services.domiciliation.pack].price
			}

			state.services.domiciliation.pack = activePack;
			state.services.domiciliation.price.withOptions += state.services.creation.packs[activePack].price
		},
		updateDomiciliationAddress(state) {
			state.services.domiciliation.addresses.forEach(address => {
				if (state.services.domiciliation.domiciliation.address.name === address.text) {
					Object.assign(state.services.domiciliation.domiciliation.address, address.address);
				} else if (state.services.creation.company.headOffice.address.name === address.text) {
					Object.assign(state.services.creation.company.headOffice.address, address.address);
				}
			});
		}
	}
})
